/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-02 11:34:13
 * @LastEditors: linxi
 * @LastEditTime: 2023-08-03 17:31:25
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../app/store'
import { checkParams, getApplyRefund, getChainReview, getMarkDecoct, getPrescriptionManagement, getPrescriptionManagementDetail, listParams } from '../../services/prescriptionManagement'

// 获取处方管理列表
export const getPrescriptionManagementAsync = createAsyncThunk<
  void,
  listParams,
  RootThunkApi
>('/productCenter/getPrescriptionManagementAsync', async (params, api) => {
  return sendAsync(getPrescriptionManagement(params), api)
})

// 总部审核允许退费 [未完成]
export const getChainReviewAsync = createAsyncThunk<
  void,
  checkParams,
  RootThunkApi
>('/productCenter/getChainReviewAsync', async (params, api) => {
  return sendAsync(getChainReview(params), api)
})

// 分店申请退费  [未完成]
export const getApplyRefundAsync = createAsyncThunk<
  void,
  checkParams,
  RootThunkApi
>('/productCenter/getApplyRefundAsync', async (params, api) => {
  return sendAsync(getApplyRefund(params), api)
})

export const getMarkDecoctAsync = createAsyncThunk<
  void,
  checkParams,
  RootThunkApi
>('/productCenter/getMarkDecoctAsync', async (params, api) => {
  return sendAsync(getMarkDecoct(params), api)
})

// 获取处方管理列表详情
export const getPrescriptionManagementDetailAsync = createAsyncThunk<
  void,
  checkParams,
  RootThunkApi
>('/productCenter/getPrescriptionManagementDetailAsync', async (params, api) => {
  return sendAsync(getPrescriptionManagementDetail(params), api)
})